import { css } from 'linaria';

export const root = css`
  -webkit-text-size-adjust: 100%;
  display: flex;
  flex-direction: column;
`;

export const orderedList = css`
  margin: 0;
  padding: 0 0 0 var(--space-200);
`;

export const oListItem = css`
  display: list-item;
  list-style: outside decimal;
`;
